import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RootState } from "../../../redux/reducers/root";

import "./ToastNotification.css";

interface ToastNotificationProps {
    position?: "top-right" | "top-left" | "top-center" | "bottom-right" | "bottom-left" | "bottom-center";
    autoClose?: number | false;
    hideProgressBar?: boolean;
    newestOnTop?: boolean;
    closeOnClick?: boolean;
    pauseOnHover?: boolean;
}

const ToastNotification = (props: ToastNotificationProps): JSX.Element => {

    const { position, autoClose, hideProgressBar, newestOnTop, closeOnClick, pauseOnHover } = props;

    const toastNotificationState = useSelector((state: RootState) => state.toastifyReducer.toastNotification);

    const message = toastNotificationState.message as string;

    const type = toastNotificationState.type as string;

    useEffect(() => {
        if (message) {
            switch (type) {
                case "info":
                    toast.info(message);
                    break;
                case "success":
                    toast.success(message);
                    break;
                case "warning":
                    toast.warn(message);
                    break;
                case "error":
                    toast.error(message);
                    break;
                default:
                    toast(message);
            }
        }
    }, [message, type]);

    return (
        <>
            <ToastContainer position={position} autoClose={autoClose} hideProgressBar={hideProgressBar} newestOnTop={newestOnTop} closeOnClick={closeOnClick} pauseOnHover={pauseOnHover} />
        </>
    )
}

ToastNotification.defaultProps = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    newestOnTop: false,
    closeOnClick: false,
    pauseOnHover: true
}

export default ToastNotification;